"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.externalabi = void 0;
exports.externalabi = [
    {
        inputs: [{ internalType: 'address', name: '_rave', type: 'address' }],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: false, internalType: 'string', name: 'name', type: 'string' },
            { indexed: false, internalType: 'string', name: 'key', type: 'string' },
            { indexed: false, internalType: 'string', name: 'value', type: 'string' },
        ],
        name: 'SetText',
        type: 'event',
    },
    {
        inputs: [],
        name: 'RAVE_IDENTIFIER',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'string', name: 'name', type: 'string' }],
        name: 'getRecords',
        outputs: [{ internalType: 'string[]', name: '', type: 'string[]' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: 'name', type: 'string' },
            { internalType: 'string', name: 'key', type: 'string' },
        ],
        name: 'getText',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'rave',
        outputs: [{ internalType: 'contract IRaveBase', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: 'name', type: 'string' },
            { internalType: 'string', name: 'key', type: 'string' },
            { internalType: 'string', name: 'value', type: 'string' },
        ],
        name: 'setText',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
